import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { useBannersContext } from 'features/banners';

function Action(): JSX.Element {
  const { formatText } = useLocalization();
  const { actionId } = useBannersContext();

  const action = actionId ? formatText(`product.banners.action.content.${actionId}`) : '';

  return <button className="action">{action}</button>;
}

export { Action };
